module.exports = __webpack_public_path__ + "static/img/platform-home1.8ecb151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/platform/platform-home1.png
// module id = oPsH
// module chunks = 0